import React from 'react';
import styled from 'styled-components';
import { isMobile } from 'react-device-detect';
import Config from '../../../config';

const OfflineNotification = () => {
  return (
    <Container>
      <IconWrapper>
        <img src={Config.ImageAssets.notifications.warning} alt="icon" />
      </IconWrapper>
      <MessageWrapper>
        <Message>{Config.TextStrings.offlineMessage}</Message>
      </MessageWrapper>
      <Close>
        <img src={Config.ImageAssets.notifications.close} alt="close" />
      </Close>
    </Container>
  );
};

const Container = styled.div`
  color: white;
  background-color: ${Config.Color.warning};
  height: 80px;
  text-align: center;
  width: 100%;
  display: grid;
  padding: ${isMobile ? 0 : '16px'};
  margin: ${isMobile ? '8px 8px 0 8px' : '12px 12px 0 12px'};
  grid-template-columns: ${isMobile ? '60px auto 60px' : '80px auto 80px'};
  justify-items: center;
  border-radius: 5px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.75);
`;

const IconWrapper = styled.div`
  align-self: center;
`;

const MessageWrapper = styled.div`
  align-self: center;
  justify-self: left;
`;

const Message = styled.div`
  text-align: left;
  font-size: ${isMobile ? '12px' : '16px'};
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
`;

const Close = styled.div`
  align-self: center;
`;

export default OfflineNotification;
